import css from "styled-jsx/css";

export default css`
    .pill-with-icon-fake {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem 1rem 1rem 0;
        &--border {
          border-bottom: 1px solid #DDDDDD;
        }
        &--content {
          display: flex;
          width: 100%
        }
        &--icon-margin {
          margin-left: 1rem;
        }
        &--data {
          display:flex;
          flex-direction: column;
          justify-content: space-between;
          width: 90%;
          &--title {
            display: flex;
            align-items: end;
            height: 1.5rem;
            &--bar {
              height: 16px;
              width: 66%;
            }
          }
          &--subtitle {
            padding-top: 0.33rem;
            &--bar {
              height: 14px;
              width: 50%;
            }
          }
        }
        &--icon-background {
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          height: 2rem;
          width: 2rem;
        }
    }
`;
